import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Stack, Paper, Chip} from 'views/components';
import {BadgeOutlined as BadgeOutlinedIcon} from 'views/icons';
import {MarkdownViewer, Translate, translate} from 'views/module';

import {translateOr} from '../../format';

const CaregiverRequirements = (props) => {
  const {caregiverRequirements} = props;

  const scheduleRequirement = caregiverRequirements?.scheduleRequirement || '';
  const matchDifficulty = caregiverRequirements?.matchDifficulty || '';
  const caregiverRequirementChips = caregiverRequirements?.caregiverRequirementChips || [];

  // Loom can add a difficulty before WebsiteAdmin has a label for it, so the raw value shows.
  const renderMatchDifficultyLabel = (value) => {
    return translateOr(`loomLead.MatchDifficulty.${value}.Title`, value);
  };

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <BadgeOutlinedIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
              <Translate expression="loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.ScheduleRequirement" />
            </Typography>
            <MarkdownViewer
              value={scheduleRequirement || translate('loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.NoScheduleRequirement')}
              truncate={true}
            />
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
              <Translate expression="loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.MatchDifficulty" />
            </Typography>
            <Typography variant="body2">
              {matchDifficulty ?
                renderMatchDifficultyLabel(matchDifficulty) :
                translate('loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.NoMatchDifficulty')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{mb: 1, fontWeight: 'bold'}}>
              <Translate expression="loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.RequirementChips" />
            </Typography>
            {
              caregiverRequirementChips.length > 0 ? (
                <Box sx={{display: 'flex', gap: 1, flexWrap: 'wrap'}}>
                  {
                    caregiverRequirementChips.map((chip) => (
                      <Chip key={chip} label={chip} />
                    ))
                  }
                </Box>
              ) : (
                <Typography variant="body2">
                  <Translate expression="loomLead.LoomLeadDetail.Careplan.CaregiverRequirements.NoRequirementChips" />
                </Typography>
              )
            }
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
};

CaregiverRequirements.propTypes = {
  caregiverRequirements: PropTypes.shape({
    scheduleRequirement: PropTypes.string,
    // An empty value means the match difficulty is not analysed yet.
    matchDifficulty: PropTypes.string,
    caregiverRequirementChips: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default CaregiverRequirements;
